import { IOpenedChatIdSetAction } from './types';
import { AT_OPENED_CHAT_ID_SET } from './constants';
import { TChatId } from '../../../../../../../types/rest/IRestChat';

export const openedChatIdSetAction = (
    id: TChatId,
): IOpenedChatIdSetAction => ({
    type: AT_OPENED_CHAT_ID_SET,
    id,
});
